import { render, staticRenderFns } from "./resourceDetailList.vue?vue&type=template&id=4cb9bd27&scoped=true"
import script from "./resourceDetailList.vue?vue&type=script&lang=js"
export * from "./resourceDetailList.vue?vue&type=script&lang=js"
import style0 from "./resourceDetailList.vue?vue&type=style&index=0&id=4cb9bd27&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cb9bd27",
  null
  
)

export default component.exports